import React, { createContext, useContext, useState } from 'react';

const PageContext = createContext({ subtitle: '', setSubtitle: () => {} });

export const usePageContext = () => useContext(PageContext);

export const PageProvider = ({ children }) => {
  const [subtitle, setSubtitle] = useState('');
  return (
    <PageContext.Provider value={{ subtitle, setSubtitle }}>
      {children}
    </PageContext.Provider>
  );
};
